import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const LiquidGlassCard = ({
    id = '',
    title = null,
    children,
    className = '',
    variant = 'default',
    size = 'medium',
    ...props
}) => {
    const cardClasses = [
        'liquid-glass-card',
        `liquid-glass-card--${variant}`,
        `liquid-glass-card--${size}`,
        className || ''
    ].filter(Boolean).join(' ');

    return (
        <div
            {...(id ? { id } : {})}
            className={cardClasses}
            {...props}
        >
            {title && (
                <div className="liquid-glass-card__title">
                    {title}
                </div>
            )}
            <div className="liquid-glass-card__content">
                {children}
            </div>
        </div>
    );
};

LiquidGlassCard.propTypes = {
    id: PropTypes.string,
    title: PropTypes.node,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    variant: PropTypes.oneOf(['default', 'auth', 'elevated', 'subtle']),
    size: PropTypes.oneOf(['small', 'medium', 'large', 'xl']),
};

export default LiquidGlassCard;
